'use-strict';

/* =====================================================
   SAFE MONEY FORMATTER (DO NOT REMOVE)
===================================================== */
function formatMoneySafe(cents) {
  if (typeof cents === "undefined" || cents === null) return "";

  if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
    return Shopify.formatMoney(
      cents,
      Shopify.money_format || "₹ {{amount_no_decimals}}"
    );
  }

  return "₹" + (cents / 100).toFixed(2);
}

function updatePriceBreakup(variantId) {
  
  const script = document.getElementById("variant-price-breakup");
  if (!script) return;

  const data = JSON.parse(script.textContent);
  const v = data[variantId];

  //console.log(v);
  if (!v) return;
  
  // TOTAL PRICE
  const totalEl = document.querySelector(".total-price-display");
  if (totalEl) {
    totalEl.innerHTML = formatMoneySafe(v.total_price);
  }

  // GOLD PRICE
  const goldPriceEl = document.querySelector(".total-price-gold-display");
  if (goldPriceEl) {
    goldPriceEl.innerHTML = formatMoneySafe(v.gold_price);
  }
  
  
  // Diamond PRICE
  const diamondDiscountedPriceEl = document.querySelector(".discounted-price");
  if (diamondDiscountedPriceEl) {
    diamondDiscountedPriceEl.innerHTML = formatMoneySafe(v.discounted_diamond_price);
  }
  const diamondPriceEl = document.querySelector(".original-price");
  if (diamondPriceEl) {
    diamondPriceEl.innerHTML = formatMoneySafe(v.diamond_price);
  }

// Making Charges
const makingDiscountedPriceEl = document.querySelector(".making_price .discounted-price");
if (makingDiscountedPriceEl) {
  makingDiscountedPriceEl.innerHTML = formatMoneySafe(v.making_discount_price);
}
const makingPriceEl = document.querySelector(".making_price .original-price");
if (makingPriceEl) {
  makingPriceEl.innerHTML = formatMoneySafe(v.making_price);
}


  // GOLD WEIGHT
  const goldWeightEl = document.querySelector(".gold-weight-display");
  if (goldWeightEl) {
    goldWeightEl.innerHTML = `Gold (${v.gold_weight}g)`;
  }


  //console.log(v);
  // DIAMOND DISCOUNT BADGE
  const discountBadge = document.querySelector(".discount-badge");
  if (discountBadge) {
    if (v.diamond_discount && v.diamond_discount > 0) {
      discountBadge.innerHTML = `${v.diamond_discount}% OFF`;
      discountBadge.style.display = "inline-block";
    } else {
      discountBadge.style.display = "none";
    }
  }



  // GOLD WEIGHT VALUE IN TABLE
  const goldWeightValue = document.querySelector(".gold_weight_value");
  if (goldWeightValue) {
    goldWeightValue.innerHTML = v.gold_weight;
  }




}

document.addEventListener("variant:change", function (event) {
  const variant = event.detail?.variant;
  if (!variant) return;
  
  updatePriceBreakup(variant.id);
});

/* =====================================================
   VARIANT CHANGE FALLBACK (RADIOS / DROPDOWNS)
===================================================== */
document.addEventListener("change", function (e) {
  const form = e.target.closest("form[action*='/cart/add']");
  if (!form) return;

  const variantInput = form.querySelector("[name='id']");
  if (!variantInput) return;
  
  updatePriceBreakup(variantInput.value);
});

/* =====================================================
   STICKY ADD TO CART
===================================================== */
class StickyAddCart extends Popup {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.getHeightAddToCart();
    const btn_minimal = this.querySelector("minimal-button");
    if (btn_minimal) {
      btn_minimal.addEventListener("click", this.toggle.bind(this), false);
    }
  }

  getHeightAddToCart() {
    const _this = this;
    this.main = document.querySelector(".main-product-section");
    if (!this.main) return;

    const primaryBtn = this.main.querySelector(".product-sticky-show");
    const footer = document.querySelector(".product-sticky-hide");
    if (!primaryBtn) return;

    let isVisible = true;

    window.addEventListener("scroll", function () {
      const buttonRect = primaryBtn.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        const scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;

        if (scrollTop > 200) {
          _this.classList.add("show-sticky-cart");
        } else {
          _this.classList.remove("show-sticky-cart");
        }

        if (footerRect.top < window.innerHeight) {
          isVisible = true;
        } else {
          if (!isVisible && buttonRect.top < viewportHeight && buttonRect.bottom > 0) {
            isVisible = true;
          } else if (isVisible && buttonRect.bottom <= 0) {
            isVisible = false;
            _this.classList.add("show-sticky-cart");
          }
        }
      }
    });
  }

  toggle(e) {
    const target = e.currentTarget;
    target.classList.toggle("opened");
    if (!target) return;

    const parent = target.closest("sticky-buy");
    if (!parent) return;

    const content = parent.querySelector(".expand-content");
    slideAnime({
      target: content,
      animeType: "slideToggle",
    });
  }
}
customElements.define("sticky-buy", StickyAddCart);

/* =====================================================
   GALLERY GRID
===================================================== */
class GalleryGrid extends SlideSection {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.onResize();
    setTimeout(() => {
      this.pauseMediaGrid();
      this.playMediaGrid();
    }, 300);
  }

  onResize() {
    const _this = this;
    let isMobile = window.innerWidth <= 767;

    window.addEventListener("resize", function () {
      const newIsMobile = window.innerWidth <= 767;
      if (newIsMobile !== isMobile) {
        isMobile = newIsMobile;
        _this.actionResize(isMobile);
        _this.pauseMediaGrid();
        _this.playMediaGrid();
      }
    });

    _this.actionResize(isMobile);
  }

  actionResize(isMobile) {
    const content = this.loadContent();
    const sl = document.createElement("div");
    const container = this.querySelector(".gallery-grid-js");
    if (!container) return;

    container.innerHTML = "";

    if (content) {
      if (isMobile) {
        sl.classList.add("slide-container");
        container.classList.remove("tablet-2", "mb-1", "grid-cols", "gap-small", "row-as-column-gap");
        sl.innerHTML = content;
        container.appendChild(sl);
        this.initSlide();
        this.destroy();
        this.slider = null;
      } else {
        container.classList.add("tablet-2", "mb-1", "grid-cols", "gap-small", "row-as-column-gap");
        container.innerHTML = content;
      }
    }
  }

  loadContent() {
    const content = document.createElement("div");
    const template = this.querySelector("template");
    if (!template) return "";

    if (!this.dataset.variantSelected) {
      content.appendChild(template.content.firstElementChild.cloneNode(true));
    } else {
      template.content.querySelectorAll(".slider-image").forEach((image) => {
        if (this.dataset.variantSelected === image.dataset.alt) {
          content.appendChild(image.cloneNode(true));
        }
      });

      if (!content.querySelector(".slider-image")) {
        content.appendChild(template.content.firstElementChild.cloneNode(true));
      }
    }

    return content.innerHTML;
  }

  pauseMediaGrid() {
    this.querySelectorAll(".slider-model, .slider-image").forEach((el) => {
      el.addEventListener("click", () => window.pauseAllMedia(this));
    });
  }

  playMediaGrid() {
    this.querySelectorAll(".overlay-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        window.pauseAllMedia(this);
        const container =
          btn.closest(".slider-external-video") || btn.closest(".slider-video");
        if (!container) return;

        const tpl = container.querySelector("template.video-template");
        if (!tpl) return;

        const videoBox = container.querySelector(".video-box");
        videoBox.classList.remove("d-none");
        videoBox.appendChild(tpl.content.firstElementChild.cloneNode(true));
        btn.remove();
      });
    });
  }
}
customElements.define("gallery-grid", GalleryGrid);

/* =====================================================
   COLLAPSIBLE ROW
===================================================== */
class CollapsibleRow extends HTMLElement {
  constructor() {
    super();
    this.querySelector(".detail-parent")?.addEventListener("click", this.onToggle.bind(this));
  }

  onToggle(e) {
    e.preventDefault();
    const target = this.querySelector(".detail-target");
    const parent = this.querySelector(".detail-parent");
    if (!target) return;

    slideAnime({
      target: target,
      animeType: "slideToggle",
      parent: parent,
    });
  }
}
customElements.define("collapsible-row", CollapsibleRow);

/* =====================================================
   STOCK ALERT
===================================================== */
class StockAlert extends Popup {
  constructor() {
    super();
    this.initMessage();
  }

  initMessage() {
    fetch(window.location.origin + "?section_id=form-infor")
      .then((r) => r.text())
      .then((htmlText) => {
        const html = parser.parseFromString(htmlText, "text/html");
        if (!html) return;

        const success = html.querySelector(".stockalert-form-success")?.innerHTML;
        if (window.location.href.includes("contact_posted=true") && success) {
          this.initToastJs(success);
          history.replaceState({}, document.title, location.pathname);
        }
      });
  }

  initToastJs(content = "") {
    let toast = EasyDialogBox.create(null, "dlg-toast dlg-fade", null, content, null, null, 10, 400);
    toast.onHide = toast.destroy;
    toast.show().hide(3000);
  }
}
customElements.define("stock-alert", StockAlert);


// document.addEventListener("DOMContentLoaded", function () {
//   const productData = JSON.parse(
//     document.getElementById("ProductJson-" + ShopifyAnalytics.meta.product.id).textContent
//   );

//   function updateVariantTable(variant) {
//     if (!variant) return;

//     // SKU
//     document.querySelector(".variant_sku_value").textContent = variant.sku || "";

//     // Gold weight (metafield)
//     const goldWeight = variant.metafields?.custom?.gold_weight?.value || "";
//     document.querySelector(".gold_weight_value").textContent = goldWeight ? goldWeight + " gms" : "";

//     // Option1 (Metal type/color)
//     document.querySelector(".selected_variant_first_option").textContent = variant.option1 || "";

//     // Option2 (Diamond quality)
//     const qualityCells = document.querySelectorAll(".selected_variant_second_option");
//     qualityCells.forEach(cell => {
//       cell.textContent = variant.option2 || "";
//     });

//     // Diamond metafields
//     // const weights = (variant.metafields?.custom?.diamond_weight?.value || "").split(" ");
//     // const shapes = (variant.metafields?.custom?.diamond_shape?.value || "").split(" ");
//     // const counts = (variant.metafields?.custom?.diamond_count?.value || "").split(" ");

//     // const tbody = document.querySelector(".variants-update-table table:nth-of-type(2) tbody");
//     // tbody.innerHTML = "";

//     // for (let i = 0; i < weights.length; i++) {
//     //   if (!weights[i]) continue;

//     //   const row = `
//     //     <tr>
//     //       <td class="selected_variant_second_option">${variant.option2 || ""}</td>
//     //       <td>${counts[i] || ""}</td>
//     //       <td>${shapes[i] || ""}</td>
//     //       <td>${weights[i]} ct</td>
//     //     </tr>
//     //   `;
//     //   tbody.insertAdjacentHTML("beforeend", row);
//     // }

//   }

//   // Listen to variant change (Dawn + Shopify 2.0)
//   document.addEventListener("variant:change", function (event) {
//     updateVariantTable(event.detail.variant);
//   });

//   // Fallback (if theme doesn't trigger event)
//   document.querySelectorAll("form[action*='/cart/add'] [name='id']").forEach(select => {
//     select.addEventListener("change", function () {
//       const variantId = this.value;
//       const variant = productData.variants.find(v => v.id == variantId);
//       updateVariantTable(variant);
//     });
//   });
// });
